import { ChangeDetectionStrategy, Component, Signal, computed, input, model, output } from '@angular/core';
import { ButtonType } from 'src/app/controls/models/button-type.model';
import { ButtonClickEvent } from 'src/app/controls/models/control-event.model';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, SvgIconComponent]
})
export class ButtonComponent {
    submit = model<boolean>(false);
    width = input<string>('');
    buttonStyle = model<ButtonType>(ButtonType.Secondary);
    icon = input<string>('');
    disabled = input<boolean>(false);
    buttonClick = output<ButtonClickEvent>();

    buttonStyleClass: Signal<string> = computed(() => {
        switch (this.buttonStyle()) {
            case ButtonType.Primary:
                return 'btn-primary';
            case ButtonType.Secondary:
                return 'btn-default';
            default:
                return 'btn-link';
        }
    });

    constructor() { }

    click(): void {
        this.buttonClick.emit(new ButtonClickEvent(this));
    }
}
